import React, { useState } from 'react';

const CTASection = ({ onContactClick }) => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setError('');
    try {
      const res = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      if (!res.ok) throw new Error('Failed to send');
      setSubmitted(true);
      setTimeout(() => {
        setSubmitted(false);
        setFormData({ name: '', email: '', message: '' });
      }, 4000);
    } catch {
      setError('Could not send message. Please try again.');
    } finally {
      setSending(false);
    }
  };

  return (
    <section id="contact" style={{
      backgroundColor: '#000',
      padding: '120px 0',
      borderTop: '1px solid rgba(255,255,255,0.06)',
    }}>
      <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 40px' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '80px',
          alignItems: 'start',
        }} className="cta-grid">
          {/* Left */}
          <div>
            <span style={{
              color: 'rgba(255,255,255,0.4)',
              fontFamily: "'Figtree', sans-serif",
              fontSize: '12px',
              fontWeight: '500',
              letterSpacing: '0.2em',
              textTransform: 'uppercase',
              display: 'block',
              marginBottom: '24px',
            }}>Get In Touch</span>
            <h2 style={{
              color: '#ffffff',
              fontFamily: "'Climate Crisis', sans-serif",
              fontSize: 'clamp(32px, 5vw, 64px)',
              fontWeight: '400',
              letterSpacing: '0em',
              lineHeight: '1.05',
              marginBottom: '28px',
            }}>
              Let's Build What Others Only Discuss
            </h2>
            <p style={{
              color: 'rgba(255,255,255,0.6)',
              fontFamily: "'Figtree', sans-serif",
              fontSize: '16px',
              fontWeight: '400',
              lineHeight: '1.8',
              marginBottom: '48px',
            }}>
              Strategy. Governance. Leadership. Performance.<br />
              If you are ready to operate at a higher standard.
            </p>

            <div style={{
              padding: '28px 32px',
              border: '1px solid rgba(255,255,255,0.08)',
              borderRadius: '18px',
            }}>
              <p style={{
                color: 'rgba(255,255,255,0.5)',
                fontFamily: "'Figtree', sans-serif",
                fontSize: '13px',
                fontWeight: '500',
                letterSpacing: '0.08em',
                textTransform: 'uppercase',
                marginBottom: '12px',
              }}>Pushing you to become the champion you were meant to be.</p>
              <p style={{
                color: 'rgba(255,255,255,0.9)',
                fontFamily: "'Figtree', sans-serif",
                fontSize: '22px',
                fontWeight: '700',
                letterSpacing: '-0.01em',
              }}>
                Jedrek Magdalena
              </p>
              <p style={{
                color: 'rgba(255,255,255,0.4)',
                fontFamily: "'Figtree', sans-serif",
                fontSize: '13px',
                fontWeight: '400',
                marginTop: '4px',
              }}>
                Project Manager &middot; Sports & Government Advisor &middot; Leadership Strategist
              </p>
            </div>
          </div>

          {/* Right: Contact Form */}
          <div>
            {submitted ? (
              <div style={{
                padding: '48px',
                border: '1px solid rgba(255,255,255,0.1)',
                borderRadius: '18px',
                textAlign: 'center',
              }}>
                <div style={{
                  width: '52px',
                  height: '52px',
                  borderRadius: '50%',
                  border: '1px solid rgba(255,255,255,0.2)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 20px',
                }}>
                  <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
                    <path d="M4 11l5 5L18 7" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <h3 style={{
                  color: '#ffffff',
                  fontFamily: "'Figtree', sans-serif",
                  fontSize: '20px',
                  fontWeight: '600',
                  marginBottom: '12px',
                }}>
                  Message Sent
                </h3>
                <p style={{
                  color: 'rgba(255,255,255,0.5)',
                  fontFamily: "'Figtree', sans-serif",
                  fontSize: '14px',
                  lineHeight: '1.7',
                }}>
                  Thank you for reaching out. I'll be in touch shortly.
                </p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                {[{ label: 'Full Name', key: 'name', type: 'text', placeholder: 'Your full name' },
                  { label: 'Email Address', key: 'email', type: 'email', placeholder: 'your@email.com' }].map((field) => (
                  <div key={field.key}>
                    <label style={{
                      display: 'block',
                      color: 'rgba(255,255,255,0.5)',
                      fontFamily: "'Figtree', sans-serif",
                      fontSize: '12px',
                      fontWeight: '500',
                      letterSpacing: '0.1em',
                      textTransform: 'uppercase',
                      marginBottom: '8px',
                    }}>{field.label}</label>
                    <input
                      type={field.type}
                      value={formData[field.key]}
                      onChange={(e) => setFormData({ ...formData, [field.key]: e.target.value })}
                      placeholder={field.placeholder}
                      required
                      style={{
                        width: '100%',
                        background: 'rgba(255,255,255,0.04)',
                        border: '1px solid rgba(255,255,255,0.1)',
                        borderRadius: '14px',
                        padding: '14px 16px',
                        color: '#ffffff',
                        fontFamily: "'Figtree', sans-serif",
                        fontSize: '15px',
                        outline: 'none',
                        boxSizing: 'border-box',
                        transition: 'border-color 0.2s ease',
                      }}
                      onFocus={(e) => e.target.style.borderColor = 'rgba(255,255,255,0.4)'}
                      onBlur={(e) => e.target.style.borderColor = 'rgba(255,255,255,0.1)'}
                    />
                  </div>
                ))}
                <div>
                  <label style={{
                    display: 'block',
                    color: 'rgba(255,255,255,0.5)',
                    fontFamily: "'Figtree', sans-serif",
                    fontSize: '12px',
                    fontWeight: '500',
                    letterSpacing: '0.1em',
                    textTransform: 'uppercase',
                    marginBottom: '8px',
                  }}>Message</label>
                  <textarea
                    value={formData.message}
                    onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                    placeholder="Tell me about your project or goals..."
                    required
                    rows={5}
                    style={{
                      width: '100%',
                      background: 'rgba(255,255,255,0.04)',
                      border: '1px solid rgba(255,255,255,0.1)',
                      borderRadius: '14px',
                      padding: '14px 16px',
                      color: '#ffffff',
                      fontFamily: "'Figtree', sans-serif",
                      fontSize: '15px',
                      outline: 'none',
                      resize: 'vertical',
                      boxSizing: 'border-box',
                      transition: 'border-color 0.2s ease',
                    }}
                    onFocus={(e) => e.target.style.borderColor = 'rgba(255,255,255,0.4)'}
                    onBlur={(e) => e.target.style.borderColor = 'rgba(255,255,255,0.1)'}
                  />
                </div>
                {error && (
                  <p style={{
                    color: '#ff6b7a',
                    fontFamily: "'Figtree', sans-serif",
                    fontSize: '13px',
                    margin: 0,
                  }}>
                    {error}
                  </p>
                )}
                <button
                  type="submit"
                  disabled={sending}
                  style={{
                    background: '#1B3D2A',
                    color: '#ffffff',
                    border: 'none',
                    borderRadius: '100px',
                    padding: '16px 40px',
                    fontFamily: "'Figtree', sans-serif",
                    fontSize: '14px',
                    fontWeight: '700',
                    letterSpacing: '0.04em',
                    cursor: sending ? 'default' : 'pointer',
                    transition: 'background-color 0.2s ease, transform 0.2s ease',
                    alignSelf: 'flex-start',
                    opacity: sending ? 0.7 : 1,
                  }}
                  onMouseEnter={(e) => { if (!sending) { e.currentTarget.style.backgroundColor = '#132d1e'; e.currentTarget.style.transform = 'scale(1.02)'; } }}
                  onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#1B3D2A'; e.currentTarget.style.transform = 'scale(1)'; }}
                >
                  {sending ? 'Sending...' : 'Send Message'}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 900px) {
          .cta-grid {
            grid-template-columns: 1fr !important;
            gap: 48px !important;
          }
        }
        input::placeholder, textarea::placeholder {
          color: rgba(255,255,255,0.2);
        }
      `}</style>
    </section>
  );
};

export default CTASection;
